module.exports = __webpack_public_path__ + "img/shrubs_en.6f63e1e2.svg";